import $axios from '../services/apiLms.js'
import cookie from 'vue-cookie'

const state = () => ({
    // nip: '',
})

const mutations = {
    // ASSIGN_NIP(state, payload) {
    //     state.nip = payload
    // },
}

const actions = {
    sendOtp({ commit }, nip) {
        return new Promise((resolve, reject) => {
           $axios.post(`/kepsek/auth/send-otp`, { nip })
                .then((response) => {
                    resolve(response.data.data)
                })
                .catch((error) => {
                    commit('SET_ERRORS', error.response.data, { root: true })
                    reject(error.response.data)
                })
        })
    },
    verfiyOtp({ commit }, payload) {
        return new Promise((resolve, reject) => {
           $axios.post(`/kepsek/auth/verify-otp`, payload)
                .then((response) => {
                    commit('SET_SUCCESS', response.data.message, { root: true })

                    cookie.set('token_supervisi', response.data.data.access_token, { expires: 1 })
                    commit('SET_TOKEN', response.data.data.access_token, { root: true })

                    resolve(response.data.data)
                })
                .catch(err => {
                    commit('SET_ERRORS', err, { root: true })
                    reject(err)
                })
        })
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}